module.exports = __webpack_public_path__ + "img/voryl.4cf97756.jpg";